import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

export const DatePickerSkeleton = () => {
  return (
    <Box sx={{ width: '320px', height: '240px' }}>
      <Skeleton variant="rounded" width={320} height={240} />
    </Box>
  )
}
